import React, { Component } from 'react'
import withAuthorization from '../higherOrder/withAuthorization'

import IntroQuestions from '../IntroQuestions/IntroQuestions'

class IntroQuestionsPage extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div>
                <IntroQuestions />
            </div>
        )
    }
}

const authCondition = authUser => !!authUser

export default withAuthorization(authCondition)(IntroQuestionsPage)



// WEBPACK FOOTER //
// ./src/components/pages/IntroQuestions.js